import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAcceptMediaServerIm } from '../accept-media-server-im.model';
import { IMediaServerVm } from '../media-server-vm.model';

@Injectable({ providedIn: 'root' })
export class AcceptMediaServerService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AcceptMediaServer`;
  }

  post(acceptMediaServerIm: IAcceptMediaServerIm): Observable<IMediaServerVm> {
    const headers = this.createHeaders();
    return this.http.post<IMediaServerVm>(this.baseUrl, acceptMediaServerIm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
